const TeamSide = Object.freeze({
    Home: "H",
    Visitor: "V"
});

export default TeamSide;
